module.exports = __webpack_public_path__ + "img/f3.7b856187.jpg";